export default {
  id: 'ContactNotes',
  code: 'CN',
  text: {
    'Add': '创建备忘',
    'Contact Notes': '联系人备忘',
    'Add Contact Notes': '创建联系人备忘',
    'Edit Contact Notes': '编辑联系人备忘',
    'Save': '保存',
    'Cancel': '取消',
    'Proceed to delete notes?': '确认删除备忘？',


  }
}



// WEBPACK FOOTER //
// ./src/template/Docks/ContactInfo/ContactNotes/locale.js